import primary from './primary';

const light = (params) => primary(params);

export default light;
